import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@datev/ngx-dcal';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { DetailsPageTitleService } from '../../shared/services/details-page-title.service';
import { PackageService } from '../../shared/services/package.service';
import { LetDirective, PushPipe } from '@ngrx/component';
import { InternalServerErrorComponent } from '../../components/internal-server-error/internal-server-error.component';
import { DownloadDetailsPageContentComponent } from '../../components/download-details-page-content/download-details-page-content.component';
import { NgTemplateOutlet } from '@angular/common';
import { MatCard } from '@angular/material/card';
import { LoggedOutStateComponent } from '../../components/logged-out-state/logged-out-state.component';
import { LoaderComponent } from '../../components/loader/loader.component';

@Component({
    selector: 'dp-base-software-details',
    templateUrl: './base-software-details.component.html',
    imports: [
        LetDirective,
        InternalServerErrorComponent,
        DownloadDetailsPageContentComponent,
        NgTemplateOutlet,
        MatCard,
        LoggedOutStateComponent,
        LoaderComponent,
        PushPipe,
    ],
})
export class BaseSoftwareDetailsComponent {
  isLoggedIn$ = this.authService.isLoggedIn.asObservable();

  baseSoftware$ = this.activatedRoute.params.pipe(
    take(1),
    map(params => params.id),
    switchMap(id => this.packageService.getPackageById(id)),
    tap(product => {
      this.titleService.setDetailsPageTitle(product.displayTitle);
    }),
  );

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly packageService: PackageService,
    private readonly titleService: DetailsPageTitleService,
    @Inject('Window') private readonly window: Window,
    private readonly authService: AuthenticationService,
  ) {}

  reloadPage(): void {
    this.window.location.reload();
  }
}
